export function generateDownloadUrl(path: string) {
	return `${process.env.REACT_APP_IMAGE_URL}/v1/download/file/${path}`
}
